import React, { useState, useEffect } from 'react';
import { createRoot } from 'react-dom/client';

const ReactComponent = ({ city, state, shippingMethod }) => {
  const [widgetHtml, setWidgetHtml] = useState('');

  // 1. Загружаем HTML-виджет для выбранного способа доставки
  useEffect(() => {
    if (!city || !shippingMethod || shippingMethod.includes('boxberry_courier')) return;
    
    jQuery.post(
        wp_data.ajax_url,
        {
          action: 'boxberry_update_widget_data',
          security: wp_data.boxberry_nonce,
          city,
          state,
          shipping_method: shippingMethod,
        },
        (response) => {
          if (response.success) {
            setWidgetHtml(response.data.boxberry_widget_link);
          } else {
            console.error('Boxberry: Ошибка при обновлении виджета:', response.data);
          }
        }
    );
  }, [city, state, shippingMethod]);

  // 2. Глобальные коллбэки для сохранения выбранного ПВЗ
  useEffect(() => {
    window.updateBoxberryAddress = (newAddress) => {
      const method = window.currentBoxberryMethod;
      if (!method) return;

      // Нормализуем метод: оставляем только часть до двоеточия
      const normalizedMethod = method.split(':')[0];

      let btn = document.querySelector(`.bxbbutton[data-method="${normalizedMethod}"]`);
      if (!btn) {
        console.warn('Boxberry: Кнопка с data-method', normalizedMethod, 'не найдена – используем fallback');
        btn = document.querySelector('.bxbbutton');
      }
      if (btn) {
        btn.textContent = newAddress;
        btn.dataset.address = newAddress;
      } else {
        console.warn('Boxberry: Кнопка не найдена для метода:', normalizedMethod);
      }
    };

    window.boxberrySelectCallback = (point) => {
      jQuery.post(wp_data.ajax_url, {
        action: 'boxberry_save_selected_point',
        security: wp_data.boxberry_nonce,
        point: point,
      });

      const text = `${point.Name}, ${point.Address}`;
      if (typeof window.updateBoxberryAddress === 'function') {
        window.updateBoxberryAddress(text);
      }
    };
  }, []);

  // Просто рендерим HTML-виджет, который пришел с сервера
  return <div dangerouslySetInnerHTML={{ __html: widgetHtml }} />;
};

let previousMethod = null;
const boxberryPickupMethods = ['boxberry_self', 'boxberry_self_after'];

// Функция, удаляющая все виджеты (контейнеры)
const hideWidget = () => {
  document.querySelectorAll('#boxberry-shipping-widget').forEach((el) => el.remove());
};

// Очистка куки
const deleteCookie = (name) => {
  document.cookie = `${name}=; Max-Age=0; path=/;`;
};

// Функция рендера виджета для выбранного способа доставки
const renderWidget = () => {
  const shippingInputs = document.querySelectorAll('input[type="radio"]');
  let selected = null;
  shippingInputs.forEach((input) => {
    const val = input.value || '';
    if (input.checked && val.includes('boxberry')) {
      selected = input;
    }
  });

  const currentMethod = selected?.value || '';
  const normalizedMethod = currentMethod.split(':')[0];

  if (previousMethod && boxberryPickupMethods.includes(previousMethod)) {  
    deleteCookie('bxb_code');
  }

  previousMethod = normalizedMethod;

  // Удаляем все старые виджет-контейнеры — чтобы гарантировать, что остаётся только один
  hideWidget();

  if (!selected) return;

  // Определяем контейнер для виджета — создаём его только в том элементе, который относится к выбранному способу
  const label = selected.closest('label') || selected.closest('.wc-block-components-shipping-method-option');
  if (!label) return;

  // Создаём новый контейнер и прикрепляем его к метке выбранного способа
  const container = document.createElement('div');
  container.id = 'boxberry-shipping-widget';
  container.style.marginTop = '10px';
  label.appendChild(container);

  // Сохраняем текущий метод глобально
  window.currentBoxberryMethod = selected.value;

  const city = jQuery('#shipping-city').val() || jQuery('#billing-city').val();
  const state = jQuery('#shipping-state').val() || jQuery('#billing-state').val();

  container._reactRoot = createRoot(container);
  container._reactRoot.render(
      <ReactComponent city={city} state={state} shippingMethod={selected.value} />
  );
};

// Наблюдаем за изменением DOM, чтобы отловить появление/смену способа доставки
const startObservingShippingMethods = () => {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;
        // Если узел содержит радио-инпут с boxberry или класс метода доставки
        const boxberryRadio = node.querySelector?.('input[type="radio"][value*="boxberry"]');
        const shippingBlock = node.classList?.contains('wp-block-woocommerce-checkout-shipping-methods-block');
        if (boxberryRadio || shippingBlock) {
          setTimeout(renderWidget, 100);
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
};

// Ждем появления радио-инпутов с boxberry (на случай асинхронной загрузки)
const waitForShippingMethods = (attempts = 0) => {
  const radios = document.querySelectorAll('input[type="radio"]');
  let foundBoxberry = false;
  radios.forEach((input) => {
    if ((input.value || '').includes('boxberry')) {
      foundBoxberry = true;
    }
  });
  if (foundBoxberry) {
    renderWidget();
  } else if (attempts < 20) {
    setTimeout(() => waitForShippingMethods(attempts + 1), 100);
  }
};

document.addEventListener('DOMContentLoaded', () => {
  waitForShippingMethods();
  startObservingShippingMethods();

  // При изменениях в полях адреса или выборе способа доставки — обновляем виджет
  jQuery(document).on('change input', '#billing-city, #billing-state, #shipping-city, #shipping-state', () => {
    renderWidget();
  });
  jQuery(document).on('change', 'input[type="radio"]', () => {
    renderWidget();
  });
});
